<template>
    <FormElement
        class="EntityDetailsBooleanForm"
        :label-for="id"
        :label="form.schema.title"
        :required="required"
    >
        <template #requiredIndicator>
            {{ translate('requiredLabel') }}
        </template>
        <FormInput :invalid="accessed && hasError" force-error-slot>
            <NewDropdown
                :id="id"
                :disabled="disabled || rbacDisabled"
                :options="[...booleanOptions]"
                :selected="selectedBoolOption(value)"
                @input="onBooleanFieldChange($event)"
            />
            <template #icon>
                <LockInputIcon v-if="rbacDisabled" />
            </template>
            <template v-if="accessed && error" #errorMessage>
                {{ error }}
            </template>
        </FormInput>
    </FormElement>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import NewDropdown from '@evidentid/dashboard-commons/components/Dropdown/NewDropdown.vue';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import AbstractJsonSchemaForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/AbstractJsonSchemaForm';
    import LockInputIcon from '@evidentid/dashboard-commons/components/LockInputIcon/LockInputIcon.vue';
    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaBoolean } from '@evidentid/json-schema/interfaces/JsonSchema';

    type JsonFormBoolean = JsonFormBase<JsonSchemaBoolean>;

    @Component({
        emits: [ 'change', 'input' ],
        components: { NewDropdown, FormInput, FormElement, LockInputIcon },
        inheritAttrs: false,
    })
    export default class EntityDetailsBooleanForm extends AbstractJsonSchemaForm<JsonFormBoolean, boolean> {
        private booleanOptions: DropdownOption[] = [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ];

        private selectedBoolOption(value: boolean | undefined): DropdownOption | null {
            return value === undefined ? null : { label: value ? 'Yes' : 'No', value: Boolean(value) };
        }

        private onBooleanFieldChange(option: DropdownOption): void {
            this.$emit('input', this.form.getValue(option.value));
            this.$emit('change', this.form.getValue(option.value));
        }
    }
</script>
